export default __webpack_public_path__ + "static/media/autocarro.83c047bc.svg";